import React from 'react';
import { Outlet } from 'react-router-dom';
import {
    DossierActionProvider,
    DossierGroupModal,
    DossierStepProvider,
    CancelDossierModal,
    SuspendDossierModal,
    UnsuspendDossierModal,
    OfferProvider,
} from '@europrocurement/l2d-modules';

const DossierRoot: React.FunctionComponent = function () {
    return (
        <OfferProvider>
            <DossierStepProvider>
                <DossierActionProvider>
                    <Outlet />
                    <DossierGroupModal />
                    <CancelDossierModal />
                    <SuspendDossierModal />
                    <UnsuspendDossierModal />
                </DossierActionProvider>
            </DossierStepProvider>
        </OfferProvider>
    );
};

export default DossierRoot;
